import graphql__1087f5bde7400a524857 from "./__generated__/AnswerEvents_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import EventsField from "../Form/Field/EventsField";

const AnswerEvents = props => {
  const { eventIds, none, formField } = useFragment(AnswerEvents_answer, props.answer);
  const {
    fieldName,
    label,
    required,
    maximumEvents,
    hint,
    hintPosition,
    hide,
    allowNone,
    options
  } = formField;
  const { parent } = props;

  return (
    <EventsField
      fieldName={fieldName}
      label={label}
      required={required}
      maximumEvents={maximumEvents}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      allowNone={allowNone}
      parent={parent}
      none={none}
      options={options}
      defaultValues={eventIds}
    />
  );
};

const AnswerEvents_answer = graphql__1087f5bde7400a524857;

export default AnswerEvents;
